import forEach from 'lodash/forEach';
import values from 'lodash/values';
import { Component, Input, OnInit } from '@angular/core';
import { CART_LINE_TYPES, ICakeCartLine } from '../../../cart';

@Component({
  standalone: false,
  selector: 'cart-order-line-info',
  templateUrl: './cart-order-line-info.component.html',
  styleUrls: ['./cart-order-line-info.component.scss']
})
export class CartOrderLineInfoComponent implements OnInit {
  @Input() public orderLine: ICakeCartLine;
  @Input() public currency = 'kr';

  public size: any;
  public variant: any;
  public linesByTypes: any = {};
  public TYPES: any = CART_LINE_TYPES;

  ngOnInit() {
    this._init();

    forEach(this.orderLine.orderLines, (l) => {
      this.linesByTypes[l.type].push(l);
    });
  }

  public hasExtraProducts() {
    return this.orderLine.orderLines.length > 0;
  }

  private _init() {
    this.size = this.orderLine.product.size;
    this.variant = this.orderLine.product.variant;

    forEach(values(CART_LINE_TYPES), (type) => {
      this.linesByTypes[type] = [];
    });
  }
}
